// Hummin — lightweight parallax on [data-parallax] elements
// data-parallax-speed (0-1, default 0.3) controls magnitude.

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let items = [];
  let ticking = false;

  const update = () => {
    const vh = window.innerHeight;
    items.forEach((el) => {
      const speed = parseFloat(el.dataset.parallaxSpeed || '0.3');
      const rect = el.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const offset = (center - vh / 2) * -speed;
      el.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
    });
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  const init = () => {
    items = [...document.querySelectorAll('[data-parallax]')];
    if (!items.length) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
